import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import _ from 'lodash';

import { getCampaignPermissionOrganisationId } from '../../selectors/campaign-permission-selectors';
import { getCampaignDiscussions } from '../../utils/jsonapi-functions/campaigns';
import { reportError } from '../../utils/error-handling-service';
import { timeout } from '../../utils/helper-functions';
import {
  LOAD_DISCUSSIONS,
  LOAD_DISCUSSIONS_SUCCESS,
  LOAD_DISCUSSIONS_ERROR,
  RELOAD_DISCUSSIONS,
  RELOAD_DISCUSSIONS_SUCCESS,
} from './constants';

const UNKNOWN_INFLUENCER_NAME = '[Unknown influencer]';

const getOrganisationIdFromProfile = () => {
  // Retrieves the profile data from localStorage
  const profile = localStorage.getItem('profile');
  return profile ? JSON.parse(localStorage.profile).app_metadata.dyzio.o_id : null;
};

const getIsUserSuperAdminFromProfile = () => {
  // Retrieves the profile data from localStorage
  const profile = localStorage.getItem('profile');
  return profile && JSON.parse(localStorage.profile).app_metadata.dyzio.isUserSuperAdmin;
};

export function filterDiscussionsByOrganisationId(discussions, organisationId) {
  // TODO Filtering discussions by organisation ID should be happening on the backend rather than the front.
  const isUserSuperAdmin = getIsUserSuperAdminFromProfile();

  const filteredDiscussions = {};
  if (discussions) {
    discussions.forEach(discussion => {
      const orgId = organisationId || getOrganisationIdFromProfile();
      console.log(`ORG ID: ${organisationId}`, orgId);
      const userHasDiscussion = isUserSuperAdmin || _.find(discussion.organisations, discussionOrganisation => discussionOrganisation.id === organisationId);
      if (userHasDiscussion) {
        filteredDiscussions[discussion.id] = discussion;
        if (!discussion.deliverables[0]) {
          discussion.deliverables = {};
        } else {
          const temp = {};
          discussion.deliverables.forEach(deliverable => {
            temp[deliverable.id] = deliverable;
            // discussion.deliverables[deliverable.id] = deliverable;
          });
          discussion.deliverables = temp;
        }
        if (!discussion.documents[0]) {
          discussion.documents = {};
        } else {
          const temp = {};
          discussion.documents.forEach(document => {
            temp[document.id] = document;
          });
          discussion.documents = temp;
        }
      }
    });
  }
  return filteredDiscussions;
}

export function filterDiscussionsByPermissionId(discussions, filteredDiscussions, permissionId) {
  // TODO Filtering discussions by permission ID should be happening on the backend rather than the front.
  if (discussions) {
    discussions.forEach(discussion => {
      const userIsMember = _.find(discussion.members, discussionMember => discussionMember.id === permissionId);
      if (userIsMember) {
        filteredDiscussions[discussion.id] = discussion;
      }
    });
  }
}

export function* loadDiscussions(actions) {
  try {
    const campaignId = actions.campaignId;
    const discussionsJSON = yield call(getCampaignDiscussions, campaignId);
    // Filter by the organisation that have been added to for that campaign
    const campaignPermissionOrganisationId = yield select(getCampaignPermissionOrganisationId, campaignId);

    const discussionList = yield call(filterDiscussionsByOrganisationId, discussionsJSON, campaignPermissionOrganisationId);

    const discussionsWithHandle = _.map(discussionList, discussion => {
      const influencerOrganisation = _.find(discussion.organisations, organisation => organisation.influencer !== null);
      discussion.influencerName = _.get(influencerOrganisation, 'influencer.name', UNKNOWN_INFLUENCER_NAME);
      return discussion;
    });

    yield put({ type: LOAD_DISCUSSIONS_SUCCESS, discussions: fromJS(discussionsWithHandle) });
  } catch (error) {
    console.error(error);
    reportError('LOAD_DISCUSSIONS_LIST_ERROR', error.message);
    yield put({ type: LOAD_DISCUSSIONS_ERROR, error: error.message });
  }
}

export function* reloadDiscussions(actions) {
  try {
    const { campaignId } = actions.data;
    yield call(loadDiscussions, { campaignId });

    yield call(timeout, 2000);
    yield put({ type: RELOAD_DISCUSSIONS_SUCCESS });
  } catch (error) {
    reportError('RELOAD_DISCUSSIONS_LIST_ERROR', error.message);
    yield put({ type: LOAD_DISCUSSIONS_ERROR, error: error.message });
  }
}

export function* watchReloadDiscussions() {
  yield takeLatest(RELOAD_DISCUSSIONS, reloadDiscussions);
}

export function* watchDiscussions() {
  yield takeLatest(LOAD_DISCUSSIONS, loadDiscussions);
}

export default function* discussionsListSagas() {
  yield [
    fork(watchDiscussions),
    fork(watchReloadDiscussions),
  ];
}



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-list/sagas.js
 **/